import React from 'react';
import { Handle, Position } from 'reactflow';
import './nodes.css';

const ClassificaNode = ({ data, selected }) => (
  <div className={`fnode fnode--classifica ${selected ? 'is-selected' : ''}`}>
    <Handle type="target" position={Position.Left} />
    <div className="fnode__title">{data.name || 'Classifica'}</div>
    {data.sortPriority && <div className="fnode__sub">priorità personalizzata</div>}
    <Handle type="source" position={Position.Right} />
  </div>
);

export default ClassificaNode;
